<script setup lang="ts">
import { computed, onMounted } from 'vue'
import {
  // useRoute,
  useRouter
} from 'vue-router'

// import SlackService from '../services/SlackService'

const {
  flow,
  includeConfiguratorButton = false,
  type = 'default'
} = defineProps<{
  flow: string
  includeConfiguratorButton: boolean
  type: 'default' | 'configurator' | 'baseModel'
}>()
// const route = useRoute()
const router = useRouter()

const label = computed(() => {
  const labels: any = {
    configurator: 'Configurator',
    baseModel: 'Base Model',
    default: ''
  }
  return labels[type]
})

onMounted(() => {
  // SlackService.postSimpleMessage({
  //   channel: 'dev',
  //   env: import.meta.env.VITE_APPLICATION_ENV,
  //   route: route.fullPath,
  //   text: `Error Loading ${label.value}`,
  // })
})
</script>

<template>
  <div class="w-full h-30rem flex flex-column align-items-center justify-content-center">
    <template v-if="flow === 'not-found'">
      <h2 class="text-6xl font-light text-gray-400">
        {{ label }} Not Found
      </h2>
      <p>
        Please select a different {{ label.length ? `${label} or ` : '' }}Item.
      </p>
    </template>
    <template v-if="flow === 'error'">
      <h2 class="text-6xl font-light text-gray-400">
        Error loading {{ label }} Model
      </h2>
      <p>
        Sorry about that. The dev team has been notified.
      </p>
      <div class="w-20rem mb-4">
        <div style="width:100%;height:0;padding-bottom:54%;position:relative;">
          <iframe
            src="https://giphy.com/embed/QQQoLTqkm7v3y"
            width="100%"
            height="100%"
            style="position:absolute"
            frameBorder="0"
            class="giphy-embed border-round-lg"
            allowFullScreen
          />
        </div>
        <div class="text-right">
          <a
            class="text-xs text-300 text-decoration-none"
            href="https://giphy.com/gifs/internet-typing-QQQoLTqkm7v3y"
            target="_blank"
          >via GIPHY</a>
        </div>
      </div>
    </template>
    <div>
      <p-btn
        aria-label="Go items list"
        class="p-button-outlined mx-1"
        icon="fa fa-chevron-right"
        icon-pos="right"
        label="Go To Items List"
        @click="router.push('/items')"
      />
      <p-btn
        v-if="includeConfiguratorButton"
        aria-label="Go to configurators list"
        class="p-button-outlined mx-1"
        icon="fa fa-chevron-right"
        icon-pos="right"
        label="Go To Configurator Models List"
        @click="router.push('/configurators')"
      />
      <p-btn
        aria-label="Go to base models list"
        class="p-button-outlined mx-1"
        icon="fa fa-chevron-right"
        icon-pos="right"
        label="Go To Base Models List"
        @click="router.push('/base-models')"
      />
    </div>
  </div>
</template>
